export enum CloseEventType {
	CONNECTION_FAILED = 'connection_failed',
	CONNECTION_LOST = 'connection_lost',
	CLIENT_CLOSE = 'client_close',
	SERVER_ERROR = 'server_error',
	NOT_DEFINED = 'not_defined',
	CHANNEL_CLOSED = 'channel_closed',
}
